<footer class="footer flex flex-column">
  <div class="footer-nav flex flex-column-reverse xl:flex-row xl:justify-content-between">
    <div class="footer-links flex flex-wrap justify-content-left align-items-center">
      <div class="flex justify-content-left">
        <a href="https://cos.io/">{{ 'footer.links.centerForOpenScience' | translate }}</a>
      </div>
    </div>

    <div class="footer-socials flex justify-content-center align-items-center my-4">
      @for (icon of socialIcons; track icon.name) {
        <a
          class="social-link flex align-items-center justify-content-center"
          [href]="icon.url"
          [attr.aria-label]="'footer.socials.' + icon.name | translate"
        >
          <osf-icon [iconClass]="`${icon.iconName} fa-2xl`"></osf-icon>
        </a>
      }
    </div>
  </div>

  <div
    class="footer-secondary-nav flex flex-column justify-content-center align-items-center mt-4 md:flex-row md:justify-content-between xl:mt-0"
  >
    <div class="footer-links flex flex-wrap justify-content-center mt-1">
      <a routerLink="/terms-of-use">{{ 'footer.links.termsOfUse' | translate }}</a>

      <span class="separator">|</span>

      <a routerLink="/privacy-policy">{{ 'footer.links.privacyPolicy' | translate }}</a>

      <span class="separator">|</span>

      <a href="https://status.cos.io/">{{ 'footer.links.status' | translate }}</a>

      <span class="separator">|</span>

      <a href="https://developer.osf.io/">{{ 'footer.links.api' | translate }}</a>

      <span class="separator">|</span>

      <a href="https://www.cos.io/initiatives/top-guidelines">{{ 'footer.links.topGuidelines' | translate }}</a>
    </div>

    <div class="flex justify-content-center my-3">{{ 'footer.copyright' | translate }}</div>
  </div>
</footer>
